import * as actionTypes from '../actions/actionsTypes';

const initialState = {
  formTemplatesList: {
    data: []
  },
};

export const formTemplatesListReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_FORM_TEMPLATES_LIST:
      return {
        ...state,
        formTemplatesList: action.payload,
      };
    default:
      return state;
  }
};
